import { notification } from "antd";
import axios from "axios";


// async function createOrUpdateUser(authtoken) {
export const createOrUpdateUser = async (name, password, mobile, token) =>
    await axios.post(`${process.env.REACT_APP_API}/create-or-update-user`, { name, password, mobile, token }, {
        // headers: {
        //     authtoken: authtoken
        // }
    }).then()
        .catch((err) => {
            console.log("Error :", err);
            notification.warning({
                message: err.response.data.error,
                showProgress: true,
                style: {
                    fontSize: '16px',
                    fontFamily: "Vazir",
                    direction: "rtl",
                },
            });
        })

export const currentUser = async (authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/get-user`, {}, {
        headers: {
            authtoken: authtoken
        }
    }).then()
        .catch((err) => {
            console.log("Error :", err);
            notification.warning({
                message: err.response.data.error,
                showProgress: true,
                style: {
                    fontSize: '16px',
                    fontFamily: "Vazir",
                    direction: "rtl",
                },
            });
        })
////////////////////
export const currentAdmin = async (authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/current-admin`, {}, {
        headers: {
            authtoken: authtoken
        }
    }).then()
        .catch((err) => {
            console.log("Error :", err);
        })
/////////
export const changePassword = async (email, password, token) =>
    await axios.post(`${process.env.REACT_APP_API}/change-password`, { email, password, token }, {
    }).then()
        .catch((err) => {
            console.log("Error :", err);
            notification.warning({
                message: err.response.data.error,
                showProgress: true,
                style: {
                    fontSize: '16px',
                    fontFamily: "Vazir",
                    direction: "rtl",
                },
            });
        })

export const changeAccountPassword = async (email, password, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/change-account-password`, { email, password }, {
        headers: {
            authtoken: authtoken
        }
    }).then()
        .catch((err) => {
            console.log("Error :", err);
            notification.warning({
                message: err.response.data.error,
                showProgress: true,
                style: {
                    fontSize: '16px',
                    fontFamily: "Vazir",
                    direction: "rtl",
                },
            });
        })